import React from "react";
import Button from "../../button/button";
import './checkboxFilter.scss';
import CheckAllFilter from "../checkAll/checkAllFilter";

export interface CheckboxFilterOption {
    value: string;
    checked: boolean;
}

export interface CheckboxFilterProps {
    checkboxOptions: string[] | undefined;
    defaultCheckedOptions?: string;
    filterName: string;
    submitFilter: (filter: { name: string; value: string }) => void;
}

function CheckboxFilter({ checkboxOptions, defaultCheckedOptions, filterName, submitFilter }: CheckboxFilterProps) {
    const [options, setOptions] = React.useState<CheckboxFilterOption[]>([]);

    React.useEffect(() => {
        init();
    }, [defaultCheckedOptions]);

    function init(): void {
        // get selected options
        const selectedOptions = defaultCheckedOptions ? defaultCheckedOptions.split('|') : [];
        if (checkboxOptions && checkboxOptions.length > 0) {
            checkboxOptions.map((opt: string) => {
                // Pre-select options if available
                const checkboxOption: CheckboxFilterOption = {
                    value: opt,
                    checked: selectedOptions.includes(opt) ? true : false
                }
                setOptions((prevState) => [...prevState, checkboxOption]);
            }
            );
        }
    }

    const handleCheckboxClick = (checkedOption: CheckboxFilterOption): void => {
        setOptions(prevOptions =>
            prevOptions.map(option =>
                option.value === checkedOption.value
                    ? { ...option, checked: !option.checked }
                    : option
            )
        );
    };

    function handleCheckboxSubmit(): void {
        const selectedValues = options
            .filter(option => option.checked)
            .map(option => option.value)
            .join('|');
        submitFilter({ name: filterName, value: selectedValues })
    }

    const toggleCheckAll = (check: boolean): void => {
        const allOptions = [...options];
        const allChecked = allOptions.map((opt: CheckboxFilterOption) => {
            return { ...opt, checked: check };
        });
        setOptions([...allChecked]);
    }

    return (
        <div className="checkbox-filter" data-testid="check-filter-filter">
            {options?.length ?
                <>
                    <CheckAllFilter toggleCheckAll={toggleCheckAll} />
                    <div className="checkbox-options">
                        {options?.map((opt: CheckboxFilterOption) => (
                            <div key={opt.value} className="checkbox-row" title={opt.value}>
                                <input
                                    type="checkbox"
                                    value={opt.value}
                                    id={opt.value}
                                    name={filterName}
                                    className="checkbox-input"
                                    onChange={() => handleCheckboxClick(opt)}
                                    checked={opt.checked}
                                    aria-label={`Filter by ${opt.value}`}
                                />
                                <label htmlFor={opt.value}>
                                    {opt.value}
                                </label>
                            </div>
                        ))
                        }
                    </div>
                    <div className="center-button">
                        <Button variant="button button--small" onClick={handleCheckboxSubmit}>Submit</Button>
                    </div>
                </>
                : <p> No {filterName} options available.</p>
            }
        </div>
    )
}

export default CheckboxFilter